import { Type } from '@angular/core';
import { Dictionary } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { SchoolDataResponseInterface } from '../../../data';
import { ClassGroupActions } from '../../class-group';
import { CredentialActions } from '../../credential';
import { LicenseActions } from '../../license';
import { LinkedPersonActions } from '../../linked-person';
import { ProductActions } from '../../product';
import { PurchaseActions } from '../../purchase';
import { PurchaseProductActions } from '../../purchase-product';
import { SchoolBillingActions } from '../../school-billing';
import { SchoolBillingAddressActions } from '../../school-billing-address';
import { SchoolProviderActions } from '../../school-provider';
import { SchoolRoleMappingActions } from '../../school-role-mapping';
import { SchoolRoleMappingClassGroupActions } from '../../school-role-mapping-class-group';

const fieldActionMap: Dictionary<Type<Action>> = {
  persons: LinkedPersonActions.LinkedPersonsLoaded,
  classGroups: ClassGroupActions.ClassGroupsLoaded,
  schoolRoleMappingClassGroups: SchoolRoleMappingClassGroupActions.SchoolRoleMappingClassGroupsLoaded,
  schoolRoleMappings: SchoolRoleMappingActions.SchoolRoleMappingsLoaded,
  products: ProductActions.ProductsLoaded,
  licenses: LicenseActions.LicensesLoaded,
  purchases: PurchaseActions.PurchasesLoaded,
  purchaseProducts: PurchaseProductActions.PurchaseProductsLoaded,
  schoolBillingAddresses: SchoolBillingAddressActions.SchoolBillingAddressLoaded,
  schoolProviders: SchoolProviderActions.SchoolProvidersLoaded,
  credentials: CredentialActions.CredentialsLoaded,
};

const fieldUpsertActionMap: Dictionary<Type<Action>> = {
  schoolBillings: SchoolBillingActions.UpsertSchoolBillings,
};

export class DataFieldActionFactory {
  /**
   * For a given field & data, return the appropriate 'Loaded' action containing the data.
   *
   * Example: field `"tasks"` with data `[{id: 1}]` returns `SchoolsLoaded({ tasks: [{id: 1}] })`
   */
  static getLoadedAction(field: keyof SchoolDataResponseInterface, data: any): Action {
    const fieldActionExceptions: Dictionary<() => Action> = {};

    if (fieldActionExceptions[field]) {
      return fieldActionExceptions[field]();
    }

    const FieldLoaded = fieldActionMap[field];

    return new FieldLoaded({
      [field]: data,
    });
  }

  /**
   * For a given field & data, return the appropriate 'Upsert' action containing the data.
   *
   * Example: field `"tasks"` with data `[{id: 1}]` returns `UpsertSchools({ tasks: [{id: 1}] })`
   */
  static getUpsertAction(field: keyof SchoolDataResponseInterface, data: any): Action {
    const fieldActionExceptions: Dictionary<() => Action> = {};

    if (fieldActionExceptions[field]) {
      return fieldActionExceptions[field]();
    }

    const FieldUpsert = fieldUpsertActionMap[field];

    return new FieldUpsert({
      [field]: data,
    });
  }
}
